import React, { useState } from 'react';

import Logoonly from '../clublogoonly.png';

function Apiloader({loader}) {
    // const [loader, setLoader] = useState(true);
    // const {apiloader} = props

    return (
        <div style={{ display: loader ? "block" : "none" }} id="loader-overlay">
            {/* <div class="loading">
                <div>
                    <div class="loaderClass">
                        <img src={Logoonly} alt="logoImage" />
                    </div>
                </div>
            </div> */}
            <span id="loader"></span>
        </div>
    )
}

export default Apiloader;
